import React from "react";
import { Marker } from "react-map-gl/maplibre";
import { Geo } from "../../messages";
import { MAP_CAREGIVER_ALT_SVG } from "../../utils/svgs";
import BaseMap from "../BaseMap";
import { AppIcon } from "../Generic/AppIcon";

interface Props {
  coordinates: Geo;
  zoom?: number;
}

const MapWithMarker = (props: Props) => {
  return (
    <BaseMap destination={props.coordinates} style={{ height: "100%" }} zoom={props.zoom}>
      <Marker latitude={props.coordinates.lat} longitude={props.coordinates.lng}>
        <AppIcon icon={MAP_CAREGIVER_ALT_SVG} size={50} style={{ margin: "-25px -20px" }} />
      </Marker>
    </BaseMap>
  );
};

export default MapWithMarker;
